import { Alert, Box, Button, Center, Separator, HStack, Heading, PinInput, Text, VStack } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@src/components/sco/icons';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { SEOMetadata } from '@src/components/sco/utilities/SEOMetadata';
import { useCurrentUrl } from '@src/hooks/useCurrentUrl';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useCookie } from 'react-use';
export const DevEnvAuthGate = (props: {
  children: any;
  scoDevPin?: any;
  url?: string;
}) => {
  const VALID_PIN = '1125';
  const searchParams = useSearchParams();
  const [authCookie, setAuthCookie] = useCookie('scoDevPin');
  const [pin, setPin] = useState(searchParams.get('SCO_DEV_PIN') || props.scoDevPin || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const currentUrl = useCurrentUrl();
  useEffect(() => {
    if (pin.length === 4) {
      handleSubmit();
    }
  }, [pin]);
  const authPassed = process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'production' || process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'development' || `${authCookie || props.scoDevPin || ''}` === VALID_PIN;
  const handlePinChange = (details: {
    value: string[];
  }) => {
    setPin(details.value.join(''));
    setError('');
  };
  const handleSubmit = async () => {
    if (pin !== VALID_PIN) {
      setError('Invalid PIN. Please try again.');
      setPin('');
      return;
    }
    setIsSubmitting(true);

    // Simulate a brief loading state
    setTimeout(() => {
      setAuthCookie(pin, {
        expires: 30
      }); // Cookie expires in 30 days
      setIsSubmitting(false);
    }, 500);
  };
  const getCurrentWwwUrl = () => {
    const newUrl = new URL(currentUrl);
    newUrl.hostname = currentUrl.replace(/^[^.]+\./, 'www.');
    const newUrlString = newUrl.toString();
    return newUrlString.endsWith('?') ? newUrlString.slice(0, -1) : newUrlString;
  };
  const pinNumbers = pin.split('');
  if (!authPassed) {
    return <>
        <SEOMetadata url={getCurrentWwwUrl()} />
        <Center bg={'colorPalette.bg'} minHeight={'100vh'}>
          <Box bg={'container'} maxWidth={'md'} mx={4} px={8} py={12} rounded={'lg'} shadow={'xl'} width={'full'}>
            <VStack gap={4} textAlign={'center'}>
              <Heading>Development Access</Heading>

              <Text textAlign={'center'}>Enter PIN to unlock access.</Text>

              {error && <Alert.Root rounded={'md'} status={'error'}>
                  <Alert.Indicator />
                  {error}
                </Alert.Root>}

              <VStack gap={4}>
                <HStack gap={4}>
                  <PinInput.Root autoFocus={true} invalid={!!error} value={[pinNumbers[0] || '', pinNumbers[1] || '', pinNumbers[2] || '', pinNumbers[3] || '']} onValueChange={handlePinChange}>
                    <PinInput.HiddenInput />

                    <PinInput.Control>
                      <PinInput.Input index={0} />
                      <PinInput.Input index={1} />
                      <PinInput.Input index={2} />
                      <PinInput.Input index={3} />
                    </PinInput.Control>
                  </PinInput.Root>
                </HStack>

                <Button loading={isSubmitting} loadingText={'Authenticating...'} onClick={handleSubmit}>
                  Submit
                </Button>
              </VStack>

              <Separator />
              <Box width={'full'}>
                <Button asChild _hover={{
                textDecoration: 'underline'
              }} alignItems={'center'} justifyContent={'center'} textAlign={'center'} variant={'cta'}>
                  <NextLink href={getCurrentWwwUrl()}>
                    Open on www.startups.com
                    <ExternalLinkIcon />
                  </NextLink>
                </Button>
              </Box>
            </VStack>
          </Box>
        </Center>
      </>;
  }
  return <>{props.children}</>;
};